<template>
  <div class="dialog-wrap">
    <el-dialog title="服务"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="480px">
      <el-form :model="dataForm"
               label-position="left"
               ref="formRules"
               label-width="87px"
               size="small">

        <el-form-item label="招呼语："
                      prop="default_greet_message">
          <el-input placeholder="请输入打招呼语"
                    type="textarea"
                    v-model="dataForm.default_greet_message"></el-input>
        </el-form-item>
        <el-form-item label="服务开关："
                      prop="auto_recommend_status ">
          <el-switch v-model="dataForm.auto_recommend_status"
                     :active-value="1"
                     :inactive-value="0"
                     active-color="#409EFF"
                     inactive-color="#C0CCDA">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { autoRecommedStatus } from '@/api/senior'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    serviceDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {},
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    serviceDetail(val) {
      if (val) {
        this.dataForm = { ...val }
        console.log('this.dataform', this.dataForm)
      }
    },
  },
  methods: {
    handleSubmit() {
      console.log('this.serviceDetail', this.serviceDetail)
      autoRecommedStatus({
        default_greet_message: this.dataForm.default_greet_message,
        auto_recommend_status: this.dataForm.auto_recommend_status,
        servicer_id: this.serviceDetail.id,
        servicer_type: 2,
      }).then((res) => {
        this.$emit('submit')
        this.$message.success(`操作成功`)
        this.$emit('close')
      })
    },
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}
</style>
